import { callPostApi, callDeleteApi, callPutApi, callGetApi } from "./api";

export async function getCategoryList(data) {
      try {
            const response = await callPostApi({ url: "categories", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getCategoryNormalList(data) {
      try {
            const response = await callPostApi({ url: "categories/normal-list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getCategoryHierarchyList(data = "") {
      try {
            const response = await callPostApi({ url: "categories/category-hierarchy-list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function deleteCategory(categoryId) {
      try {
            const response = await callDeleteApi({ url: "categories/" + categoryId });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function createCategory(data) {
      try {
            const response = await callPostApi({ url: "categories/add", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function updateCategory(data, categoryId) {
      try {
            const response = await callPutApi({ url: "categories/" + categoryId, body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getCategoryDetail(categoryId) {
      try {
            const response = await callGetApi({ url: "categories/" + categoryId });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function updateCategoryHierarchy(categoryId, postData) {
      try {
            const response = await callPutApi({ url: "categories/hierarchiesUpdate/" + categoryId, body: postData });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function deleteCategoryHierarchy(deleteCategoryHierarchyId) {
      try {
            const response = await callDeleteApi({ url: "categories/hierarchiesUpdate/" + deleteCategoryHierarchyId });
            return response;
      } catch (error) {
            throw error;
      }
}


